<div class="layers-container" *ngrxLet="selectionLayers$ as selectionLayers">
    <div class="loading" *ngIf="isLoading"></div>
    <ng-container *ngIf="selectionLayers.length">
        <app-layer-group
            class="group"
            [groupInfo]="{
                name: SelectionName.Free,
                id: SelectionName.Free,
                listOpen: getListOpen(SelectionName.Free, SelectionName.Free)
            }"
            [layers]="(selectionLayers$ | async) ?? []"
            [showToggleAllButtons]="true"
            (selectLayer)="toggleLayerDetailOverlay($event)"
            (selectLayerGroup)="toggleLayerGroupOverlay($event)"
            (toggleListOpen)="toggleListOpen($event, SelectionName.Free)"
        >
        </app-layer-group>
    </ng-container>

    <ng-container *ngIf="showHierarchicalSelectionLayers$ | async">
        <div *ngIf="selectionGroup$.length" class="group">
            <div class="selection-group-title">
                <button
                    class="show-toggle-button"
                    (click)="toggleGroupListOpen(SelectionName.Hierarchical)"
                >
                    <ng-container
                        *ngIf="!listOpenSelectionGroups.includes(SelectionName.Hierarchical)"
                    >
                        <img
                            class="chevron-icon"
                            src="../../../../assets/icons/chevron-right.svg"
                            alt="chevron up"
                            style="width: 0.4rem"
                        />
                    </ng-container>
                    <ng-container
                        *ngIf="listOpenSelectionGroups.includes(SelectionName.Hierarchical)"
                    >
                        <img
                            class="chevron-icon"
                            src="../../../../assets/icons/chevron-down.svg"
                            alt="chevron down"
                            style="width: 0.6rem"
                    /></ng-container>
                </button>
                <div class="title-row" #titleElement>{{ SelectionName.Hierarchical }}</div>
            </div>
            <ng-container *ngIf="listOpenSelectionGroups.includes(SelectionName.Hierarchical)">
                <div *ngFor="let group of selectionGroup$" class="selection-group-items">
                    <app-layer-group
                        class="group hierarchical-selections-group"
                        [groupInfo]="{
                            name: group.name,
                            id: group.name,
                            listOpen: getListOpen(group.name, SelectionName.Hierarchical)
                        }"
                        [layers]="group.selections"
                        [showToggleAllButtons]="true"
                        (selectLayer)="toggleLayerDetailOverlay($event)"
                        (selectLayerGroup)="toggleLayerGroupOverlay($event)"
                        (toggleListOpen)="toggleListOpen($event, SelectionName.Hierarchical)"
                    >
                    </app-layer-group>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngIf="showUnsupervisedSelectionLayers$ | async">
        <div *ngIf="unsupervisedSelectionGroup$.length" class="group">
            <div class="selection-group-title">
                <button
                    class="show-toggle-button"
                    (click)="toggleGroupListOpen(SelectionName.Unsupervised)"
                >
                    <ng-container
                        *ngIf="!listOpenSelectionGroups.includes(SelectionName.Unsupervised)"
                    >
                        <img
                            class="chevron-icon"
                            src="../../../../assets/icons/chevron-right.svg"
                            alt="chevron up"
                            style="width: 0.4rem"
                        />
                    </ng-container>
                    <ng-container
                        *ngIf="listOpenSelectionGroups.includes(SelectionName.Unsupervised)"
                    >
                        <img
                            class="chevron-icon"
                            src="../../../../assets/icons/chevron-down.svg"
                            alt="chevron down"
                            style="width: 0.6rem"
                        />
                    </ng-container>
                </button>
                <div class="title-row" #titleElement>{{ SelectionName.Unsupervised }}</div>
            </div>
            <ng-container *ngIf="listOpenSelectionGroups.includes(SelectionName.Unsupervised)">
                <div
                    *ngFor="let group of unsupervisedSelectionGroup$"
                    class="selection-group-items"
                >
                    <app-layer-group
                        class="group hierarchical-selections-group"
                        [groupInfo]="{
                            name: group.name,
                            id: group.name,
                            listOpen: getListOpen(group.name, SelectionName.Unsupervised)
                        }"
                        [layers]="group.selections"
                        [showToggleAllButtons]="true"
                        (selectLayer)="toggleLayerDetailOverlay($event)"
                        (selectLayerGroup)="toggleLayerGroupOverlay($event)"
                        (toggleListOpen)="toggleListOpen($event, SelectionName.Unsupervised)"
                    >
                    </app-layer-group>
                </div>
            </ng-container>
        </div>
    </ng-container>

    <ng-container *ngrxLet="viewerLayers.layerGroups$ as layerGroups">
        <app-layer-groups
            [layerGroups]="layerGroups"
            (layerSelected)="toggleLayerDetailOverlay($event)"
            (layerGroupSelected)="toggleLayerGroupOverlay($event)"
        ></app-layer-groups>
    </ng-container>
</div>

<ng-template cdkPortal>
    <ng-container *ngIf="detailView$ | async; else allLayers">
        <ng-container *ngrxLet="detailViewLayer$ as layer">
            <div class="single-layer-detail-overlay">
                <app-single-layer-detail
                    (close)="closeLayerDetailOverlay()"
                    [layer]="layer"
                    [colorPalette]="colorPalette"
                ></app-single-layer-detail>
            </div>
        </ng-container>
    </ng-container>
    <ng-template #allLayers>
        <ng-container *ngrxLet="viewAllLayers$ as layers">
            <ng-container *ngrxLet="layerGroupOverlayTitle$ as title">
                <div class="layer-group-detail-overlay">
                    <app-layer-group-detail
                        (close)="closeLayerGroupOverlay()"
                        [layers]="layers"
                        [title]="title"
                    ></app-layer-group-detail>
                </div>
            </ng-container>
        </ng-container>
    </ng-template>
</ng-template>
